export function getAndroidUserId(){
  if(typeof(window.tailgJs) != 'undefined'){
    let userId = window.tailgJs.getUserId()
    return userId
  } 
}
export function getAndroidToken(){
  if(typeof(window.tailgJs) != 'undefined'){
    let userId = window.tailgJs.getToken()
    return userId
  } 
}

export function formWhere(){
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if(isAndroid){
    return 'android'
  }else if(isiOS){
    return 'ios'
  }else{
    return 'other'
  }
}